import { AppBar, Box, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import Config from "app/config";

/**
 * Styled header
 */
export const Root = styled(AppBar, {
  label: "header-root"
})(({ theme }) => ({
  height: 64,
  backgroundColor: "#fff",
  borderBottom: "1px solid #e2e5e3",
  color: "#1a1a1a",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    minHeight: 64
  }
}));

/**
 * Styled logo toolbar content component
 */
export const HeaderToolbar = styled(Toolbar, {
  label: "header-toolbar"
})(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 28px !important",
  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
    flexDirection: "column",
    gap: theme.spacing(1),
    padding: "12px 16px !important"
  }
}));

/**
 * Styled logo container component
 */
export const LogoContainer = styled(Box, {
  label: "logo-container"
})(() => ({
  display: "flex",
  width: 150
}));

/**
 * Styled header logo container component
 */
export const HeaderLogo = styled(Box, {
  label: "header-logo"
})(() => ({
  width: "100%",
  backgroundImage: `url(${Config.get().theme.logoPath})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  height: 62
}));

/**
 * Styled form logo container component
 */
export const FormLogo = styled(Box, {
  label: "form-logo"
})(() => ({
  position: "absolute",
  bottom: 20,
  right: 20,
  backgroundImage: `url(${Config.get().theme.formLogoPath})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  height: 80,
  width: "100%",
  backgroundPosition: "right"
}));

export default Root;